module.exports = __webpack_public_path__ + "img/16581262_S.d6a19b56.png";